import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarEventType } from 'src/app/models/calendar-event-type';
import { Country } from 'src/app/models/country';

export interface CalendarFilterPopupComponentData {
  allCountries: Country[];
  allTopicGroups: CalendarEventType[];
  selectedCountries: Country[];
  selectedTopicGroups: CalendarEventType[];
}

@Component({
  selector: 'app-calendar-filter-popup',
  templateUrl: './calendar-filter-popup.component.html',
  styleUrls: ['./calendar-filter-popup.component.scss'],
})
export class CalendarFilterPopupComponent implements OnInit {
  // Note that we're mixing two metaphors here for managing the form - ngModel
  // for the countries, and a FormArray for the topics. This was because we copied
  // the country handling logic from the User Edit popup, and that was built back
  // when we were using ngModel for everything.

  form = new UntypedFormGroup({
    topics: new UntypedFormArray([]),
    selectAll: new UntypedFormControl(''),
  });

  get topics(): UntypedFormArray {
    return this.form.get('topics') as UntypedFormArray;
  }

  get selectAll(): UntypedFormControl {
    return this.form.get('selectAll') as UntypedFormControl;
  }

  public toggleAllTopics(e: MatCheckboxChange) {
    this.topics.controls.forEach((control) => {
      control.setValue(e.checked);
    });
    this.updateSelectedTopicGroups();
  }

  public updateSelectedTopicGroups() {
    this.data.selectedTopicGroups = [];
    for (let index = 0; index < this.form.get('topics').value.length; index++) {
      if (this.form.get('topics').value[index]) {
        this.data.selectedTopicGroups.push(this.data.allTopicGroups[index]);
      }
    }
  }

  constructor(
    public dialogRef: MatDialogRef<CalendarFilterPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CalendarFilterPopupComponentData
  ) { }

  ngOnInit(): void {
    this.data.allTopicGroups.forEach((t) => {
      const initialValue = this.data.selectedTopicGroups.find(
        (x) => x.slug === t.slug
      )
        ? true
        : false;
      (this.form.controls.topics as UntypedFormArray).push(
        new UntypedFormControl(initialValue)
      );
    });
    this.form.controls.selectAll.setValue(this.data.selectedTopicGroups.length === this.data.allTopicGroups.length);
  }
}
